import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { readProfile } from "../actions/auth";
import { StarFilled } from "@ant-design/icons";
import moment from "moment";

const ProfileModal = ({ user, extra }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setProfileName();
    setProfileEmail();
    setProfileRatings([]);
    setRatingAverage();
  };
  const handleShow = () => setShow(true);

  const [profileName, setProfileName] = useState();
  const [avatar, setAvatar] = useState(null);
  const [profileEmail, setProfileEmail] = useState();
  const [profileRatings, setProfileRatings] = useState([]);
  const [ratingAverage, setRatingAverage] = useState();
  const [countRides, setCountRides] = useState();
  const [createdAt, setCreatedAt] = useState();

  const loadProfile = async (e) => {
    const user = e.currentTarget.id;
    readProfile(user).then((res) => {
      handleShow();
      setAvatar(res.data.profile.avatar);
      setProfileName(res.data.profile.name);
      setProfileEmail(res.data.profile.email);
      setProfileRatings(res.data.all);
      setCountRides(res.data.count);
      setCreatedAt(res.data.profile.createdAt);
      let numbers = res.data.all;
      setRatingAverage(
        numbers.reduce((sum, { rating }) => sum + rating, 0) / numbers.length
      );
    });
  };
  return (
    <div className={`${extra}`}>
      <div
        onClick={loadProfile}
        id={user}
        style={{ cursor: "pointer" }}
        className="chat-main-info-profile-link d-flex align-items-center ml-auto"
      >
        <span>Profil ansehen</span>
      </div>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="profile-tab-top d-flex">
              <div className="profile-tab-top-image">
                <img src={avatar} alt="PB" />
              </div>
              <div
                style={{ flexDirection: "row", marginLeft: "10px" }}
                className="profile-tab-top-details d-flex justify-content-between"
              >
                <div className="d-flex align-items-center">
                  <h2
                    className="profile-name"
                    style={{
                      fontSize: "22px",
                      color: "#363636",
                      marginBottom: "0",
                    }}
                  >
                    {profileName}
                  </h2>
                  <div className="d-flex align-items-start">
                    <b
                      style={{
                        marginRight: "3px",
                        color: "#777",
                        fontSize: 14,
                      }}
                    >
                      {typeof ratingAverage === "number" &&
                        ratingAverage.toFixed(1)}{" "}
                    </b>
                    <StarFilled
                      style={{ color: "rgb(250, 182, 20)", fontSize: 16 }}
                    />
                    <div
                      style={{
                        marginLeft: "3px",
                        color: "#777",
                        fontSize: 14,
                      }}
                    >
                      ({profileRatings && profileRatings.length})
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="border-container mb-3" style={{ boxShadow: "none" }}>
            <div className="dashboard-container-top d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h3 className="container-heading">Allgemeines</h3>
              </div>
            </div>
            <div className="dashboard-container-body">
              <div className="dashboard-body-row d-flex align-items-center justify-space-between">
                <span className="profile-info-general-text">
                  Abgeschlossene Fahrten:
                </span>
                <span className="profile-info-general-text-right">
                  {countRides && countRides}
                </span>
              </div>
              <div className="dashboard-body-row d-flex align-items-center justify-space-between">
                <span className="profile-info-general-text">
                  Registriert seit:
                </span>
                <span className="profile-info-general-text-right">
                  {createdAt && createdAt.split("T")[0]}
                </span>
              </div>
            </div>
          </div>
          <div className="border-container" style={{ boxShadow: "none" }}>
            <div className="dashboard-container-top d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <h3 className="container-heading">Bewertungen</h3>
              </div>
            </div>
            <div className="dashboard-container-body dashboard-rating-body">
              {profileRatings.length === 0 && (
                <div className="dashboard-container-empty-body">
                  Der User hat noch keine Bewertungen erhalten.
                </div>
              )}
              {profileRatings.map((rating) => (
                <div key={rating._id} className="dashboard-body-row">
                  <div className="d-flex">
                    <div className="rating-img-container">
                      <img src={rating.user.avatar} alt="avatar" />
                    </div>
                    <div className="rating-text-container">
                      <div className="rating-text-top d-flex align-items-center">
                        <p>{rating.user.name}</p>
                        <div className="d-flex align-items-center">
                          <div>
                            <b
                              style={{
                                marginRight: "3px",
                                color: "#777",
                                fontSize: 14,
                              }}
                            >
                              ({rating.rating})
                            </b>
                          </div>
                          <StarFilled
                            style={{
                              color: "rgb(250, 182, 20)",
                              fontSize: 14,
                            }}
                          />
                        </div>
                      </div>
                      <div className="rating-text-message">
                        <p>{rating.ratingText}</p>
                      </div>
                    </div>
                    <div className="rating-date-container">
                      <p>{moment(rating.createdAt).fromNow}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ProfileModal;
